import React from 'react'
import styled from 'styled-components'

const ContentWrapper = styled.div`
@media all {
  .page-break {
    display: none;
  }
}
 
@media print {
    html, body {
        height: initial !important;
        overflow: initial !important;
        -webkit-print-color-adjust: exact;
    }
}
 
@media print {
    .page-break {
        margin-top: 1rem;
        display: block;
        -webkit-column-break-inside: avoid;
        page-break-before: auto;
        break-inside: auto;
    }
}
 
@page {
    size: auto;
    margin: 20mm;
}
`

const ContentPrintWrapper = ({ children }) => {
  return <ContentWrapper className="page-break">{children}</ContentWrapper>
}

export default ContentPrintWrapper